module.exports = __webpack_public_path__ + "static/img/location.7d03d48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/location.jpg
// module id = dq0S
// module chunks = 1